import day from 'utils/day';

export const createdPatientNutritionGoal = {
  id: 4,
  nutritionGoalId: 48,
  weight: '220',
  height: '61',
  activityLevel: 'Sedentary',
  gender: 'Male',
  age: 74,
  deficit: 'moderate',
  calorieAmount: 1500,
  createdBy: 174,
  updatedBy: 174,
  assignDate: '2021-07-20T10:03:03.992Z',
  patientId: 110,
  updatedAt: '2021-07-20T10:03:03.993Z',
  createdAt: '2021-07-20T10:03:03.993Z',
  endDate: null,
};

export const patientNutritionGoal = {
  data: {
    id: 30,
    deficit: null,
    weight: 12,
    height: 189,
    activityLevel: null,
    assignDate: '2021-06-02T10:38:15.880Z',
    endDate: null,
    createdAt: '2021-06-02T10:38:15.881Z',
    updatedAt: '2021-06-02T10:38:15.881Z',
    patientId: 187,
    nutritionGoalId: 44,
    nutrition_goal: {
      id: 1,
      name: 'Nutrition Goal 1',
    },
  },
  height: 155,
  weight: 50,
  age: 65,
  activityLevel: 'Sedentary',
  gender: 'Male',
};

const todayDate = day();

export const noNutritionGoal = {
  [todayDate.format('YYYY-MM-DD')]: {
    weight: 220,
    height: 61,
    activityLevel: 'Sedentary (e.g., desk job, no structured activity)',
    gender: 'Male',
    age: 70,
  },
};

export const nutritionGoal = {
  [todayDate.format('YYYY-MM-DD')]: {
    id: 1,
    deficit: 'mild',
    gender: 'Male',
    activityLevel: 'Sedentary',
    weight: '220',
    height: '61',
    age: 61,
    calorieAmount: 1750,
    assignDate: '2021-07-30',
    endDate: null,
    createdAt: '2021-07-30T22:19:53.097Z',
    updatedAt: '2021-07-30T22:19:53.097Z',
    patientId: 110,
    nutritionGoalId: 51,
    createdBy: 248,
    updatedBy: 248,
    nutrition_goal: {
      id: 51,
      name: 'Very Low Carbohydrate / Ketogenic Diet',
      rules: [
        {
          title: 'Calories',
          equation: 'Custom',
          male: {
            total: 2000,
            mild: {
              amount: 250,
              measurement: 'Calories',
            },
            moderate: {
              amount: 500,
              measurement: 'Calories',
            },
            major: {
              amount: 750,
              measurement: 'Calories',
            },
          },
          female: {
            total: 2000,
            mild: {
              amount: 250,
              measurement: 'Calories',
            },
            moderate: {
              amount: 500,
              measurement: 'Calories',
            },
            major: {
              amount: 750,
              measurement: 'Calories',
            },
          },
        },
        {
          title: 'Protein',
          measurement: 'Percentage',
          operator: 'Between',
          minValue: 10,
          maxValue: 20,
        },
        {
          title: 'Fat',
          measurement: 'Percentage',
          operator: 'Between',
          minValue: 70,
          maxValue: 80,
        },
        {
          title: 'Carbs',
          measurement: 'Grams',
          operator: 'Less Then',
          value: 50,
        },
      ],
    },
    name: 'Very Low Carbohydrate / Ketogenic Diet',
    rules: [
      {
        title: 'Calories',
        equation: 'Custom',
        male: {
          total: 2000,
          mild: {
            amount: 250,
            measurement: 'Calories',
          },
          moderate: {
            amount: 500,
            measurement: 'Calories',
          },
          major: {
            amount: 750,
            measurement: 'Calories',
          },
        },
        female: {
          total: 2000,
          mild: {
            amount: 250,
            measurement: 'Calories',
          },
          moderate: {
            amount: 500,
            measurement: 'Calories',
          },
          major: {
            amount: 750,
            measurement: 'Calories',
          },
        },
      },
      {
        title: 'Protein',
        measurement: 'Percentage',
        operator: 'Between',
        minValue: 10,
        maxValue: 20,
      },
      {
        title: 'Fat',
        measurement: 'Percentage',
        operator: 'Between',
        minValue: 70,
        maxValue: 80,
      },
      {
        title: 'Carbs',
        measurement: 'Grams',
        operator: 'Less Then',
        value: 50,
      },
    ],
  },
};

export const nutritionGoalData = {
  activityLevel: 'Sedentary',
  age: 51,
  data: {
    id: 1,
    deficit: 'moderate',
    gender: 'Male',
    activityLevel: 'Sedentary',
    weight: '220',
    height: '61',
    age: 51,
    calorieAmount: 1500,
    assignDate: '2021-07-20T12:04:12.948Z',
    endDate: null,
    createdAt: '2021-07-20T12:04:12.948Z',
    updatedAt: '2021-07-20T12:04:12.948Z',
    patientId: 110,
    nutritionGoalId: 48,
    createdBy: 174,
    updatedBy: 174,
    nutrition_goal: {
      id: 48,
      name: 'Nutrition Goal 1',
      rules: [
        {
          title: 'Calories',
          equation: 'Custom',
          male: {
            total: 2000,
            mild: {
              amount: 1750,
              measurement: 'Calories',
            },
            moderate: {
              amount: 1500,
              measurement: 'Calories',
            },
            major: {
              amount: 1250,
              measurement: 'Calories',
            },
          },
          female: {
            total: 1550,
            mild: {
              amount: 1300,
              measurement: 'Calories',
            },
            moderate: {
              amount: 1000,
              measurement: 'Calories',
            },
            major: {
              amount: 750,
              measurement: 'Calories',
            },
          },
        },
        {
          title: 'Protein',
          measurement: 'None',
        },
        {
          title: 'Fat',
          measurement: 'None',
        },
        {
          title: 'Carbs',
          measurement: 'None',
        },
      ],
    },
  },
  gender: 'Male',
  height: 61,
  weight: 220,
};

export const weeklyNutritionGoals = {
  [day().day(6).format('YYYY-MM-DD')]: {
    weekDay: 'Sat',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(5).format('YYYY-MM-DD')]: {
    weekDay: 'Fri',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(4).format('YYYY-MM-DD')]: {
    weekDay: 'Thu',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(3).format('YYYY-MM-DD')]: {
    weekDay: 'Wed',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(2).format('YYYY-MM-DD')]: {
    weekDay: 'Tue',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(1).format('YYYY-MM-DD')]: {
    weekDay: 'Mon',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
  [day().day(0).format('YYYY-MM-DD')]: {
    weekDay: 'Sun',
    ...nutritionGoal[todayDate.format('YYYY-MM-DD')],
  },
};
